var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-scroll",
    {
      ref: "scroll",
      attrs: {
        width: _vm.width,
        toX: _vm.toX,
        toY: _vm.toY,
        sliderWidth: 4,
        toIndex: _vm.toIndex,
        overflow: _vm.overflow,
        isBlock: _vm.isBlock,
      },
      on: { mounted: _vm.setPosition },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }